import BasicRouterView from "../../components/BasicRouterView.vue";

const gdcRoutes = {
  path: "gdc",
  redirect: { name: "gestao-contratos-listagem" },
  meta: {
    label: "Gestão de Contratos",
    icon: "download",
    permissioOnly: false,
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "gestao-contratos/gestao-contratos-listagem",
      name: "gestao-contratos-listagem",
      meta: {
        label: "Lista de Contratos",
        icon: "list",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/ContratoListagem.vue"),
    },
    {
      path: "gestao-contratos/detalhe-contrato/:id?",
      name: "detalhe-contrato",
      meta: {
        label: "Detalhe do Contrato",
        icon: "visibility",
        permissioOnly: false,
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DetalheContrato.vue"),
    },
    {
      path: "gestao-contratos/gestao-contratos-relatorio/:id?",
      name: "gestao-contratos-relatorio",
      meta: {
        label: "Relatório de Contratos",
        icon: "assessment",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/RelatorioContrato.vue"),
    },
    {
      path: "gestao-contratos/gestao-contratos-relatorio-vinculos/:id?",
      name: "gestao-contratos-relatorio-vinculos",
      meta: {
        label: "Relatório de Vínculos",
        icon: "assessment",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/RelatorioVinculos.vue"),
    },
    {
      path: "gestao-contratos/gestao-contratos-tipo-fornecedor",
      name: "gestao-contratos-tipo-fornecedor",
      meta: {
        label: "Tipo de Fornecimento",
        icon: "person",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/TipoFornecedor.vue"),
    },
    {
      path: "relatorio-vinculos-requisicao/:id?",
      name: "gestao-contratos-relatorio-vinculos-requisicao",
      meta: {
        label: "Relatório de Vínculos Requisição",
        icon: "receipt_long",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "gdc" */ "./views/RelatorioVinculosRequisicao.vue"
        ),
    },
    {
      path: "relatorio-produtos-contrato/:id?",
      name: "gestao-contratos-relatorio-produtos-contrato",
      meta: {
        label: "Relatório de Produtos Contrato",
        icon: "inventory_2",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "gdc" */ "./views/RelatorioProdutosContrato.vue"
        ),
    },
  ],
};

export default gdcRoutes;
